export default "__VITE_ASSET__Aktlewle__"